import { apiSlice } from "application/api/apiSlice";
import { API_PREFIX } from "data/constants";

export const authHostSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginHost: builder.mutation({
      query: (host) => ({
        url: API_PREFIX + "/host/login",
        method: "POST",
        body: host,
      }),
      invalidatesTags: ["Host"],
    }),
    registerHost: builder.mutation({
      query: (host) => ({
        url: API_PREFIX + "/host/sign-up",
        method: "POST",
        body: host,
      }),
      invalidatesTags: ["Host"],
    }),
    resetPswHost: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/host/resetPassword",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Host"],
    }),
    createNewPasswordHost: builder.mutation({
      query: (client) => ({
        url: API_PREFIX + "/host/createNewPassword",
        method: "POST",
        body: client,
      }),
      invalidatesTags: ["Host"],
    }),
  }),
});

export const {
  useLoginHostMutation,
  useRegisterHostMutation,
  useResetPswHostMutation,
  useCreateNewPasswordHostMutation,
} = authHostSlice;
